var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUpicon = function SvgThumbsUpicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.96 4.237a1.53 1.53 0 0 0-1.148-.518H8.97v-.656A2.409 2.409 0 0 0 6.563.655a.656.656 0 0 0-.587.363L3.969 5.03H1.75A1.094 1.094 0 0 0 .656 6.125v4.813A1.094 1.094 0 0 0 1.75 12.03h9.406a1.531 1.531 0 0 0 1.52-1.341l.656-5.25a1.532 1.532 0 0 0-.371-1.203ZM1.97 6.344h1.75v4.375h-1.75V6.344ZM12.03 5.277l-.656 5.25a.219.219 0 0 1-.219.192H5.031V5.842l1.904-3.808a1.094 1.094 0 0 1 .721 1.029v1.312a.656.656 0 0 0 .657.656h3.5a.218.218 0 0 1 .218.246Z"
  })));
};
export default SvgThumbsUpicon;